import React, { useState } from 'react'
import "./FilterGraphicFinincs.css"

const FilterGraphicFinincs = () => {

    return (

        <div className='d-flex align-items-center justify-content-center'>
            <select
                className='form-control text-justify text-title-charts '>
                <option>Relatório Mensal</option>
                <option>Relatório Diário</option>
                <option>Relatório Semanal</option>
                <option>Relatório Trimestral</option>
                <option>Relatório Semestral</option>
                <option>Relatório Anual</option>
            </select>

            <div>|</div>

            <select
                className='form-select text-title-charts'>
                <option>2024</option>
                <option>2025</option>
                <option>2026</option>
            </select>
            <hr></hr>
        </div>
    )
}

export default FilterGraphicFinincs